import { useId } from 'react'

import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Label, RadioGroup, RadioGroupItem } from '@/components/ui'
import { FormField } from '@/components/ui/form'
import { CardEtapaContent, CardEtapaItem } from '@/features/proposta/shared/components/ui/card-etapa'

const ASSINATURA_PATH = 'detalhesDaProposta.assinaturaContrato'
const TERMOS_PATH = 'detalhesDaProposta.termosDaProposta'

export const AssinaturaContratoStepBase = () => {
  const id = useId()
  const { t } = useTranslation('proposta')
  const { control, watch, setValue } = useFormContext()

  const handleSelecionarTipoAssinatura = () => {
    if (!watch(TERMOS_PATH)) return
    setValue(TERMOS_PATH, '')
  }

  return (
    <CardEtapaItem
      titulo={t('detalhes_proposta.assinaturas.titulo')}
      descricao={t('detalhes_proposta.assinaturas.descricao')}
      completed={Boolean(watch(ASSINATURA_PATH))}
    >
      <CardEtapaContent>
        <span className="text-sm font-medium text-neutral-800">
          {t('detalhes_proposta.assinaturas.modelo_assinatura')}
        </span>
        <FormField
          name={ASSINATURA_PATH}
          control={control}
          render={({ field }) => (
            <RadioGroup
              className="flex flex-col gap-6"
              value={field.value}
              onValueChange={(v) => {
                field.onChange(v)
                handleSelecionarTipoAssinatura()
              }}
            >
              <div className="flex items-center gap-2">
                <RadioGroupItem value="Eletronica" id={`${id}-Eletronica`} />
                <Label className="font-normal" htmlFor={`${id}-Eletronica`}>
                  {t('detalhes_proposta.assinaturas.options.eletronica')}
                </Label>
              </div>
              <div className="flex items-center gap-2">
                <RadioGroupItem value="Impressa" id={`${id}-Impressa`} />
                <Label className="font-normal" htmlFor={`${id}-Impressa`}>
                  {t('detalhes_proposta.assinaturas.options.impressa')}
                </Label>
              </div>
            </RadioGroup>
          )}
        />
      </CardEtapaContent>
    </CardEtapaItem>
  )
}
